"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGMainMenuScene = void 0;
const CTGMenuScene_1 = require("../CTGMenuScene");
const CTGGameModes_1 = require("../CTGGameModes");
class CTGMainMenuScene extends CTGMenuScene_1.CTGMenuScene {
    constructor() {
        super("CTGMainMenuScene");
    }
    onCreate() {
        super.onCreate();
        this.setTitle("What a Card!");
        // const rand = new KHRandomGeneral();
        // for (let i = 0; i < 4; i++) {
        //     for (let j = 0; j < 4; j++) {
        //         this.add.sprite(1 + i * 14, 1 + j * 15, 'c6', CTGCard.randomCard(rand).imageId()).setOrigin(0)
        //     }
        // }
        this.addOption("Play", null, () => {
            this.startScene('CTGGameInfoScene', { game_modes: CTGGameModes_1.game_modes });
        });
        this.addOption("Forever", null, () => {
            this.startScene('CTGGameScene', { game_modes: CTGGameModes_1.game_mode_zen, level: 0 });
        });
        this.addOption("Practice", null, () => {
            this.startScene('CTGPracticeScene');
        });
        this.addOption("Options", null, () => {
            this.startScene('CTGOptionsScene');
        });
        this.addOption("Credits", null, () => {
            this.startScene('CTGCreditsScene');
        });
    }
}
exports.CTGMainMenuScene = CTGMainMenuScene;
